export enum AgentContractStateEnum {
    'waiting_for_approval' = 'waiting_for_approval',
    'returned_to_creation' = 'returned_to_creation',
    'approved' = 'approved',
    'rejected' = 'rejected',
    'waiting_for_invalidation' = 'waiting_for_invalidation',
    'returned_to_invalidation' = 'returned_to_invalidation',
    'invalidated' = 'invalidated',
}
